import { PERSONA_PROFILE_FIXED_FIELDS, PERSONA_DATA_FIELD_PREFIX, isForbiddenPersonaDataTitle } from './personaWidgetTypes'

// De waarden van 'Traject en gegevens' uit de documenten van één deelnemer.
// Nodig omdat de widget in de app zijn eigen documenten leest, terwijl de
// openbare link een kant-en-klaar `profile` van de server krijgt
// (functions/liveReports/publicPersonaData.js → loadProfile). Beide geven
// dezelfde vorm, zodat de widget daarna één weg heeft: personaProfileRows.
//
// Dezelfde regels als de server — personaProfile.parity.test.js in functions/
// houdt ze gelijk. De frontend is de bron.
// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T9)

const isShown = (value) => value !== undefined && value !== null && value !== ''

/**
 * @param {object} input
 * @param {Array<string>} input.fields - `Settings.fields` van de widget
 * @param {object} input.persona - Het `Personas`-doc (niet verwijderd)
 * @param {Array<{ID: string, Title?: string}>} input.routes - `PersonaRoutes` van de organisatie (niet verwijderd)
 * @param {Array<{Title?: string, Value?: *, Position?: number}>} input.dataRows - `PersonaData` van deze deelnemer (niet verwijderd)
 * @returns {Object<string, *>} Waarde per gekozen sleutel; lege of onbekende velden ontbreken
 */
const personaProfileFromDocs = ({ fields, persona, routes, dataRows }) => {
    const profile = {}
    if (!Array.isArray(fields) || fields.length === 0 || !persona) return profile

    const fixedKeys = fields.filter((key) => PERSONA_PROFILE_FIXED_FIELDS[key])
    fixedKeys.filter((key) => key !== 'Route').forEach((key) => {
        const value = persona[PERSONA_PROFILE_FIXED_FIELDS[key].source]
        if (isShown(value)) profile[key] = value
    })

    if (fixedKeys.includes('Route') && persona.RouteID) {
        const route = (routes || []).find((r) => r.ID === persona.RouteID)
        if (route && isShown(route.Title)) profile.Route = route.Title
    }

    const dataTitles = new Set(fields
        .filter((key) => key.startsWith(PERSONA_DATA_FIELD_PREFIX))
        .map((key) => key.slice(PERSONA_DATA_FIELD_PREFIX.length))
        .filter((title) => !isForbiddenPersonaDataTitle(title)))
    if (dataTitles.size > 0) {
        // Bij dubbele titels wint de eerste ingevulde op Position, net als op de server.
        [...(dataRows || [])]
            .sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0))
            .forEach((row) => {
                const key = `${PERSONA_DATA_FIELD_PREFIX}${row.Title}`
                if (dataTitles.has(row.Title) && !(key in profile) && isShown(row.Value)) profile[key] = row.Value
            })
    }
    return profile
}

export { personaProfileFromDocs }
export default personaProfileFromDocs
